export const onChangeIsDesktop = 'shared/change-isDesktop';
